// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import VueParticles from './vue-particles'
import VuePrism from 'vue-prism'
import Progress from 'vue-multiple-progress'
Vue.use(Progress)
Vue.use(VueParticles, VuePrism)

Vue.config.productionTip = false


Vue.prototype.clickButton = () => {
	let buttonAudio = document.getElementById('buttonAudio');
	buttonAudio.setAttribute('src', 'static/ui.mp3')
	buttonAudio.play()
}
document.body.addEventListener('click', function(e) {
	let event = e || window.event;
	let target = event.target || event.srcElement;
	let clickMusic = target.getAttribute('clickMusic')
	if (clickMusic === 'true') Vue.prototype.clickButton()
	else return false;
})
/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	components: {
		App
	},
	template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js